import Skeleton from "@mui/material/Skeleton";
import styles from "./new.module.scss";

const sk = (props: any) => <Skeleton animation="wave" variant="rectangular" {...props} />;

function ChatHomeSkeleton(): JSX.Element {
  return (
    <div className={styles.superContainer}>
      <div className={styles.desktopScrollContainer}>
        <div className={styles.contentContainer}>
          <div style={{ display: "flex", alignItems: "center", gap: "12px" }}>
            {sk({ width: 40, height: 40, sx: { borderRadius: "50%" } })}
            {sk({ width: 200, height: 20, sx: { borderRadius: "4px" } })}
          </div>
        </div>
      </div>
      <div className={styles.inputContainer}>
        <div style={{ display: "flex", gap: "8px", overflow: "hidden", paddingBottom: "12px" }}>
          {[132, 104, 108, 96].map((w, i) => (
            <span key={i} style={{ flexShrink: 0 }}>
              {sk({ width: w, height: 40, sx: { borderRadius: "200px" } })}
            </span>
          ))}
        </div>
        {sk({ width: "100%", height: 56, sx: { borderRadius: "200px" } })}
      </div>
    </div>
  );
}

export default ChatHomeSkeleton;
